import { Checkbox } from '@mantine/core';
import classes from './checkbox.module.css';
export const checkboxProps = Checkbox.extend({
    classNames: classes,
    defaultProps: {
        size: 'md',
    },
});
